module.exports = __webpack_public_path__ + "static/img/pic_rjyf_xmal02.e4fed167.png";